module.exports = __webpack_public_path__ + "static/media/processing.bcc63029.png";